export default __webpack_public_path__ + "static/media/pic2.88844162.jpg";